import type jsPDF from 'jspdf';

export const PDF_UNICODE_FONT = 'NotoSansArabic';

const FONT_URL = '/fonts/NotoSansArabic-Regular.ttf';
const FONT_FILE = 'NotoSansArabic-Regular.ttf';

let fontDataPromise: Promise<string> | null = null;

const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
  const bytes = new Uint8Array(buffer);
  const chunkSize = 0x8000;
  let binary = '';

  for (let offset = 0; offset < bytes.length; offset += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(offset, offset + chunkSize));
  }

  return btoa(binary);
};

const loadFontData = () => {
  if (!fontDataPromise) {
    fontDataPromise = fetch(FONT_URL)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Unable to load PDF font (${response.status})`);
        }
        return response.arrayBuffer();
      })
      .then(arrayBufferToBase64)
      .catch(error => {
        fontDataPromise = null;
        throw error;
      });
  }

  return fontDataPromise;
};

export async function configurePdfUnicodeFont(pdf: jsPDF) {
  const fontData = await loadFontData();

  pdf.addFileToVFS(FONT_FILE, fontData);
  pdf.addFont(FONT_FILE, PDF_UNICODE_FONT, 'normal');
  pdf.addFont(FONT_FILE, PDF_UNICODE_FONT, 'bold');
  pdf.setFont(PDF_UNICODE_FONT, 'normal');
}
